/*
 * Author: Duncan Levings
 * 
 * Copyright (c) 2022 DuncanLevings
 */

export default {
    BRONZE_MAN_ITEM: 0,
    BRONZE_MAN_ENEMY: 1
}